/**
 * Background Images Configuration
 * 
 * Controls the daily background rotation for the application.
 * All users see the same background for a given day.
 * 
 * To add new backgrounds:
 * 1. Add images to public/backgrounds/
 * 2. Run: npm run process-backgrounds
 * 3. Update the backgrounds array below with new paths
 */

// List of processed background images (optimized WebP format)
export const backgrounds = [
  '/backgrounds_processed/bg-4.webp',
  '/backgrounds_processed/bg-5.webp',
  '/backgrounds_processed/bg-6.webp',
  '/backgrounds_processed/bg-10.webp',
];

/**
 * Get the background image for the current day.
 * Same background is shown to all users for a given day.
 * Changes at midnight based on day of year.
 * 
 * @returns {string} Path to the background image for today
 */
export const getDailyBackground = () => {
  const today = new Date();
  const startOfYear = new Date(today.getFullYear(), 0, 0);
  const diff = today - startOfYear;
  const oneDay = 1000 * 60 * 60 * 24;
  const dayOfYear = Math.floor(diff / oneDay);
  
  return backgrounds[dayOfYear % backgrounds.length];
};

/**
 * Get background by index (for testing or preview purposes)
 * 
 * @param {number} index - Index of the background (0-based)
 * @returns {string} Path to the background image
 */
export const getBackgroundByIndex = (index) => {
  const safeIndex = Math.abs(index) % backgrounds.length;
  return backgrounds[safeIndex];
};

/**
 * Get total number of available backgrounds
 * 
 * @returns {number} Total count of backgrounds
 */
export const getBackgroundCount = () => backgrounds.length;
